import React from 'react'
import PageHeader from 'components/PartnershipsSite/PageHeader'
import { THEME } from 'utils'

const SponsorshipSecondary = ({ title, details, top, bottom, centerSectionBreak }) => {
  return (
    <>
      <div className='audio_container'>
        <PageHeader title={title} details={details} />
        {top}
        <div className='audio_4'>
          <h2 style={{ textAlign: centerSectionBreak ? 'center' : 'auto' }}>Ways to Buy</h2>
        </div>
        {bottom}
      </div>
      <style jsx>{`
        .audio_container {
          height: 100%;
          width: 100%;
          margin: 0 auto;
          background-color: #f5f5f5;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow: hidden;
        }
        .audio_container > div {
          width: 100%;
        }
        .audio_4 {
          background-color: #de4444;
          padding: 1.5rem;
          color: #ffffff;
          font-size: 0.8rem;
        }
        @media (min-width: 370px) {
          .audio_4 {
            font-size: 0.85rem;
          }
        }
        @media (min-width: 400px) {
          .audio_4 {
            font-size: 0.9rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .audio_4 {
            padding: 2.5rem;
            font-size: 1.1rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.LG}px) {
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .audio_4 {
            padding: 3rem 3.5rem;
            font-size: 1.3rem;
          }
        }
      `}</style>
    </>
  )
}

export default SponsorshipSecondary
